import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
import { Badge } from "@mui/material";
// component
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";

// store
import { StoreContext } from "../../../../../../store/StoreProvider";
import Act from "../../../../../../store/actions";
// config,utils
import { MODULE_ID } from "../../../../../../config/CONSTANTS";
import urls from "../../../../../../api/project/ApiUrls";
import useModulePublic from "../../../../../hooks/useModulePublic";

// style

function a11yProps(index) {
  return {
    id: `sidebar-filetool-tab-${index}`,
    "aria-controls": `sidebar-filetool-tab-${index}`,
  };
}

const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: "#fff",
  },
}));

const StyledTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "&.MuiTab-root": {
    width: "50%",
    paddingX: "15px",
  },
  "&.MuiTab-textColorInherit": {
    color: "#fff",
    fontSize: "14px",
  },
  "& .Mui-selected": {
    color: "#fff",
  },
}));

const CustomTabs = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { sidebarFileTool, dataset } = sna;
  // local state
  const [curTabIdx, setCurTabIdx] = useState(sidebarFileTool.tabIdx);
  const [datasetSelect, setDatasetSelect] = useState([]);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  const handleChange = (event, newValue) => {
    setCurTabIdx(newValue);
    dispatch({
      type: Act.SNA_SIDEBAR_FILE_TOOL,
      payload: { ...sidebarFileTool, tabIdx: newValue },
    });
  };

  const getBadgeNum = (type) =>
    datasetSelect.filter((el) => el.datasetType === type).length;

  useEffect(() => {
    const newDatasetSelect = Object.entries(dataset).reduce(
      (acc, [key, list]) => {
        if (key === "select") return acc;
        (list || []).forEach((file) => {
          if (file.checked) {
            acc.push({ ...file, datasetType: key });
          }
        });
        return acc;
      },
      []
    );
    setDatasetSelect(newDatasetSelect);
  }, [dataset]);

  const tabs = [
    {
      label: intl.formatMessage({
        id: "snaPage.sidebar.file.personal",
        defaultMessage: "個人",
      }),
      index: 0,
      badgeType: "personal",
      public: handlePublic(MODULE_ID.snaSidebarFilePersonal),
    },
    {
      label: intl.formatMessage({
        id: "snaPage.sidebar.file.group",
        defaultMessage: "團隊",
      }),
      index: 1,
      badgeType: "public",
      public: handlePublic(MODULE_ID.snaSidebarFileGroup),
    },
  ];

  return (
    <Box display="inline-block">
      <StyledTabs
        value={curTabIdx}
        textColor="inherit"
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        {tabs
          .filter((tab) => tab.public)
          .map((item, idx) => (
            <StyledTab
              key={idx.toString()}
              label={`${item.label} (${getBadgeNum(item.badgeType)})`}
              {...a11yProps(item.index)}
            />
          ))}
      </StyledTabs>
    </Box>
  );
};

CustomTabs.propTypes = {};

CustomTabs.defaultProps = {};

export default CustomTabs;
